import {
	InstantSearch as InstantSearchDef,
	InstantSearchProps
} from 'react-instantsearch-hooks-web'

import {Autocomplete} from 'blocks/search/Autocomplete'
import algoliasearch from 'algoliasearch/lite'
import css from './headersearchinput.module.scss'
import {fromModule} from 'util/styler/Styler'
import {useApp} from 'AppContext'
import {useMemo} from 'react'

const InstantSearch =
	InstantSearchDef as unknown as React.FC<InstantSearchProps>

const styles = fromModule(css)

const algoliaClient = algoliasearch(
	process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
	process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
)

const searchClient: typeof algoliaClient = {
	...algoliaClient,
	search(requests) {
		if (requests.every(({params}) => !params.query)) {
			return Promise.resolve({
				results: requests.map(() => ({
					__isArtificial: true,
					hits: [],
					nbHits: 0,
					nbPages: 0,
					page: 0,
					processingTimeMS: 0,
					hitsPerPage: 0,
					exhaustiveNbHits: false,
					query: '',
					params: ''
				}))
			})
		}
		return algoliaClient.search(requests)
	}
}

export const HeaderSearchInput: React.FC = () => {
	const {lang} = useApp()
	const onSearch = useMemo(() => {
		return (query: string) => {
			;(window as any).location =
				`/${lang}/search?q=` + encodeURIComponent(query)
		}
	}, [lang])

	return (
		<InstantSearch
			searchClient={searchClient}
			indexName={process.env.NEXT_PUBLIC_ALGOLIA_INDEX + '_pages'}
		>
			<Autocomplete
				searchClient={searchClient}
				className={styles.headersearchinput()}
				onSearch={onSearch}
				placeholder="Search"
				detachedMediaQuery="none"
				openOnFocus
				autoFocus
				qsIndex={process.env.NEXT_PUBLIC_ALGOLIA_INDEX + '_pages_qs'}
			/>
		</InstantSearch>
	)
}
